import { Link } from "react-router-dom";
import { hotTags } from "../../../mocks/manga";

const accents = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-800",
  "bg-secondary-100 text-secondary-900",
  "bg-background-100 text-foreground-700",
];

export default function TagsSection() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16" aria-labelledby="tags-heading">
      <div className="mb-6">
        <h2 id="tags-heading" className="font-display text-2xl text-foreground-950 md:text-3xl">
          热门标签
        </h2>
        <p className="mt-1 text-sm text-foreground-500">按标签筛选作品，找漫追更更省心</p>
      </div>
      <div className="flex flex-wrap gap-2.5">
        {hotTags.map((tag, idx) => (
          <Link
            key={tag}
            to={`/library?tag=${encodeURIComponent(tag)}`}
            className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-transform hover:-translate-y-0.5 ${accents[idx % accents.length]}`}
          >
            <i className="ri-price-tag-3-line text-sm" aria-hidden="true"></i>
            {tag}
          </Link>
        ))}
      </div>
    </section>
  );
}